import { render } from "./KSelect.vue?vue&type=template&id=458ff228"
import script from "./KSelect.vue?vue&type=script&lang=js"
export * from "./KSelect.vue?vue&type=script&lang=js"

import exportComponent from "/home/azael/Documents/GitHub/tempo-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__